import { List, styled } from '@mui/material';
import { IconButton } from 'components/IconButton';

export const StyledBurgerIconButton = styled(IconButton)(() => ({
	display: 'flex',
}));

export const StyledBurgerMenuList = styled(List)({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
});
